import { render, staticRenderFns } from "./NewGroupConversation.vue?vue&type=template&id=51e63512&scoped=true&"
import script from "./NewGroupConversation.vue?vue&type=script&lang=js&"
export * from "./NewGroupConversation.vue?vue&type=script&lang=js&"
import style0 from "./NewGroupConversation.vue?vue&type=style&index=0&id=51e63512&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e63512",
  null
  
)

export default component.exports